// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33r8M","content":"styles_content__22_eh","row":"styles_row__2CHY8","footer":"styles_footer__2bmDn","phraseLength":"styles_phraseLength__1okRK"};